export default __webpack_public_path__ + "hero-md-05fe529390338579b45d8275bcd24012.digested.webp";